import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './transitions.css';

import './fonts/Ambit/Ambit-Bold.woff';
import './fonts/Ambit/Ambit-Bold.woff2';
import './fonts/Ambit/Ambit-Regular.woff';
import './fonts/Ambit/Ambit-Regular.woff2';
import './fonts/Ambit/Ambit-SemiBold.woff';
import './fonts/Ambit/Ambit-SemiBold.woff2';
import './fonts/Ambit/Ambit-Thin.woff';
import './fonts/Ambit/Ambit-Thin.woff2';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
